import { render } from "./PrivacypolicyPage.vue?vue&type=template&id=6e3afe24&scoped=true"
import script from "./PrivacypolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacypolicyPage.vue?vue&type=script&lang=js"

import "./PrivacypolicyPage.vue?vue&type=style&index=0&id=6e3afe24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3afe24"]])

export default __exports__